import MaterialTable from 'material-table';
import * as React from 'react';
import { compose } from 'recompose';
import { createStyles, ThemeProvider } from '@material-ui/styles';
import cn from 'classnames';
import { withBaseProps } from '../Utils';
import { getMuiTheme } from './materialTableTheme';
import { MATERIAL_TABLE_TRANSLATIONS } from './materialTableTranslations';
const styles = () => createStyles({
    tableContainer: {
        height: '100%',
    },
});
const StaticDatatable = (props) => {
    const { t, classes, title, data, options, theme, columns, actions = [], compactTable, disableHoverRow, components, onSelectionChange, className: classNameProp, testId = 'StaticDatatable', } = props;
    const defaultOptions = {
        draggable: false,
        searchFieldStyle: {
            color: 'white',
        },
        headerStyle: {
            backgroundColor: title ? theme.components.table.th.background : theme.color.brand.main,
            color: title ? theme.components.table.th.color : theme.color.font.light,
        },
        ...options,
    };
    return (React.createElement("div", { className: cn(classes.tableContainer, classNameProp), "data-testid": `${testId}` },
        React.createElement(ThemeProvider, { theme: getMuiTheme(theme, compactTable, !!title) },
            React.createElement(MaterialTable, { onRowClick: disableHoverRow
                    ? undefined
                    : (e) => {
                        return e;
                    }, title: title, options: defaultOptions, columns: columns, actions: actions, data: data, components: components, onSelectionChange: onSelectionChange, localization: MATERIAL_TABLE_TRANSLATIONS(t) }))));
};
export default compose(withBaseProps({ styles }))(StaticDatatable);
//# sourceMappingURL=StaticDatatable.js.map